exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:300,400,500,700);", ""]);

// module
exports.push([module.id, ".banner {\n  margin-top: 20px;\n  width: 80vw; }\n\n@media only screen and (max-width: 600px) {\n  .banner {\n    width: calc(100vw - 20px);\n    padding: 0 10px; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/screens/banner/Banner.scss
// module id = 1663
// module chunks = 0